/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AdjuntoIncidenciaModelDto } from '../models/adjunto-incidencia-model-dto';
import { AlertasModelDto } from '../models/alertas-model-dto';
import { doctorAlertaControllerMarcarAlertaLeida } from '../fn/doctor-alertas/doctor-alerta-controller-marcar-alerta-leida';
import { DoctorAlertaControllerMarcarAlertaLeida$Params } from '../fn/doctor-alertas/doctor-alerta-controller-marcar-alerta-leida';
import { doctorAlertaControllerObtenerAdjuntoIncidencia } from '../fn/doctor-alertas/doctor-alerta-controller-obtener-adjunto-incidencia';
import { DoctorAlertaControllerObtenerAdjuntoIncidencia$Params } from '../fn/doctor-alertas/doctor-alerta-controller-obtener-adjunto-incidencia';
import { doctorAlertaControllerObtenerAlertas } from '../fn/doctor-alertas/doctor-alerta-controller-obtener-alertas';
import { DoctorAlertaControllerObtenerAlertas$Params } from '../fn/doctor-alertas/doctor-alerta-controller-obtener-alertas';
import { doctorAlertaControllerObtenerDetalleAlerta } from '../fn/doctor-alertas/doctor-alerta-controller-obtener-detalle-alerta';
import { DoctorAlertaControllerObtenerDetalleAlerta$Params } from '../fn/doctor-alertas/doctor-alerta-controller-obtener-detalle-alerta';
import { ListadoAlertasModelDto } from '../models/listado-alertas-model-dto';

@Injectable({ providedIn: 'root' })
export class DoctorAlertasService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `doctorAlertaControllerObtenerAlertas()` */
  static readonly DoctorAlertaControllerObtenerAlertasPath = '/api/doctor-alertas/obtener-alertas';

  /**
   * Obtener alertas.
   *
   * Obtiene una lista de alertas con paginación.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorAlertaControllerObtenerAlertas()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorAlertaControllerObtenerAlertas$Response(params?: DoctorAlertaControllerObtenerAlertas$Params, context?: HttpContext): Observable<StrictHttpResponse<ListadoAlertasModelDto>> {
    return doctorAlertaControllerObtenerAlertas(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener alertas.
   *
   * Obtiene una lista de alertas con paginación.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorAlertaControllerObtenerAlertas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorAlertaControllerObtenerAlertas(params?: DoctorAlertaControllerObtenerAlertas$Params, context?: HttpContext): Observable<ListadoAlertasModelDto> {
    return this.doctorAlertaControllerObtenerAlertas$Response(params, context).pipe(
      map((r: StrictHttpResponse<ListadoAlertasModelDto>): ListadoAlertasModelDto => r.body)
    );
  }

  /** Path part for operation `doctorAlertaControllerObtenerDetalleAlerta()` */
  static readonly DoctorAlertaControllerObtenerDetalleAlertaPath = '/api/doctor-alertas/detalle-alerta/{uuid}';

  /**
   * Obtener detalle alerta.
   *
   * Obtiene el detalle de una alerta específica.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorAlertaControllerObtenerDetalleAlerta()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorAlertaControllerObtenerDetalleAlerta$Response(params: DoctorAlertaControllerObtenerDetalleAlerta$Params, context?: HttpContext): Observable<StrictHttpResponse<AlertasModelDto>> {
    return doctorAlertaControllerObtenerDetalleAlerta(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener detalle alerta.
   *
   * Obtiene el detalle de una alerta específica.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorAlertaControllerObtenerDetalleAlerta$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorAlertaControllerObtenerDetalleAlerta(params: DoctorAlertaControllerObtenerDetalleAlerta$Params, context?: HttpContext): Observable<AlertasModelDto> {
    return this.doctorAlertaControllerObtenerDetalleAlerta$Response(params, context).pipe(
      map((r: StrictHttpResponse<AlertasModelDto>): AlertasModelDto => r.body)
    );
  }

  /** Path part for operation `doctorAlertaControllerObtenerAdjuntoIncidencia()` */
  static readonly DoctorAlertaControllerObtenerAdjuntoIncidenciaPath = '/api/doctor-alertas/obtener-adjunto-incidencia/{uuidIncidencia}';

  /**
   * Obtener adjunto de una incidencia.
   *
   * Obtiene el adjunto de una incidencia
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorAlertaControllerObtenerAdjuntoIncidencia()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorAlertaControllerObtenerAdjuntoIncidencia$Response(params: DoctorAlertaControllerObtenerAdjuntoIncidencia$Params, context?: HttpContext): Observable<StrictHttpResponse<AdjuntoIncidenciaModelDto>> {
    return doctorAlertaControllerObtenerAdjuntoIncidencia(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener adjunto de una incidencia.
   *
   * Obtiene el adjunto de una incidencia
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorAlertaControllerObtenerAdjuntoIncidencia$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorAlertaControllerObtenerAdjuntoIncidencia(params: DoctorAlertaControllerObtenerAdjuntoIncidencia$Params, context?: HttpContext): Observable<AdjuntoIncidenciaModelDto> {
    return this.doctorAlertaControllerObtenerAdjuntoIncidencia$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdjuntoIncidenciaModelDto>): AdjuntoIncidenciaModelDto => r.body)
    );
  }

  /** Path part for operation `doctorAlertaControllerMarcarAlertaLeida()` */
  static readonly DoctorAlertaControllerMarcarAlertaLeidaPath = '/api/doctor-alertas/marcar-alerta-leida/{uuid}';

  /**
   * Marcar alerta como leída.
   *
   * Marca una alerta específica como leída.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorAlertaControllerMarcarAlertaLeida()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorAlertaControllerMarcarAlertaLeida$Response(params: DoctorAlertaControllerMarcarAlertaLeida$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return doctorAlertaControllerMarcarAlertaLeida(this.http, this.rootUrl, params, context);
  }

  /**
   * Marcar alerta como leída.
   *
   * Marca una alerta específica como leída.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorAlertaControllerMarcarAlertaLeida$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorAlertaControllerMarcarAlertaLeida(params: DoctorAlertaControllerMarcarAlertaLeida$Params, context?: HttpContext): Observable<void> {
    return this.doctorAlertaControllerMarcarAlertaLeida$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
